<template>
  <div style="margin: 15px 10px">
    <el-image class="fl" :src="src" style="width: 100px; height: 100px"></el-image>
    <div class="fl ml_15">
      <p>
        <span>商品名：{{ `四肢我精美连衣裙` }}</span>
        <span class="ml_30">款式编码：{{ `12312124` }}</span>
      </p>
      <p>商品编码：{{ `编码12312124` }}</p>
      <p>
        已打印商品数：<span style="color: #dc8623">{{ 111 }}</span>
      </p>
      <p>
        <el-input-digit
          ref="inputDigit"
          autofocus
          v-model.number="num"
          placeholder="请输入需打印数量"
          :precision="0"
          style="width: 150px; margin-right: 10px;"
        />
        <el-button type="primary" @click="handleSetValue">去打印</el-button>
      </p>
    </div>
  </div>
</template>

<script>
import no_pic from '@/assets/images/no_pic.png';

export default {
  props: {
    info: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      src: no_pic,
      num: '',
    };
  },
  watch: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.fl {
  float: left;
}
.ml_15 {
  margin-left: 15px;
}
.ml_30 {
  margin-left: 30px;
}
.ml_10 {
  margin-left: 10px;
}
</style>
